import styled from 'styled-components';

import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { laptopAndAbove } from '@sorare/core/src/style/mediaQuery';

export const PickerOptionsGrid = styled(Horizontal).attrs({
  gap: 1,
  center: true,
})`
  flex-wrap: wrap;
  justify-content: center;
  align-items: stretch;

  --padding: var(--unit);
  padding: var(--padding);
  max-width: calc(3 * 130px + 2 * var(--unit) + 2 * var(--padding));

  > * {
    flex: 0 0 clamp(100px, calc((100% - 2 * var(--unit)) / 3), 130px);
  }

  @media ${laptopAndAbove} {
    --padding: var(--double-unit);
  }
`;
